import React from 'react';
import * as S from './Home.styles';
import { TabBar } from '@/components/TabBar/TabBar';
import { PageTopControls } from '@/components/PageTopControls';
import { AndroidAppBanner } from '@/components/AndroidAppBanner/AndroidAppBanner';
import { useBanner } from '@/hooks/useBanner';
import { useMobileDetect } from '@/hooks/useMobileDetect';
import { CatalogueGrid } from '@/components/CatalogueGrid/CatalogueGrid';
import { Header } from '@/components/Header';
import { SearchPanel } from '@/components/SearchPanel';
import { useResponsive } from '@/hooks/useResponsive';
import { PremiumAdsWithInfiniteScroll } from '@/components/AdsWithInfiniteScroll/PremiumAdsWithInfiniteScroll';
import { PopularRequests } from '@/components/PopularRequests';
import { useBannerStore } from '@/store/useBannerStore/useBannerStore';
import { useServerDataContext } from '@/contexts';

export const HomeView = () => {
  const { isAndroid } = useMobileDetect();
  const { isDesktop } = useResponsive();
  const { topBanner, backgroundBanner } = useBanner({ isDesktop });
  const { rootCategories: serverRootCategories } = useServerDataContext();
  const canLoadBanners = useBannerStore(state => state.canLoadBanners);

  return (
    <>
      {isAndroid && canLoadBanners && <AndroidAppBanner />}

      {canLoadBanners && topBanner}
      {backgroundBanner}

      <PageTopControls>
        <Header isMain />
        {!isDesktop && (
          <>
            <SearchPanel hideOnDesktop />
            <CatalogueGrid serverRootCategories={serverRootCategories} />
          </>
        )}
      </PageTopControls>

      <S.Wrapper>
        {isDesktop && (
          <CatalogueGrid serverRootCategories={serverRootCategories} />
        )}

        <PremiumAdsWithInfiniteScroll />

        <PopularRequests />

        {isDesktop ? <S.DesktopFooter /> : <S.MobileFooter />}

        {!isDesktop && <TabBar />}
      </S.Wrapper>
    </>
  );
};
